import  { useEffect, useState } from 'react'
import { Footer } from '../../components/footer';
import { useLocation, useNavigate } from 'react-router-dom';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import AirdropReward from './AirdropReward';
import RedeemReward from './RedeemReward';


const RewardView = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const [activeTab, setActiveTab] = useState('airdropreward');

    const toggle = tab => {
        if (activeTab !== tab) setActiveTab(tab);
    }

    useEffect(() => { if (!location?.state?.back) { setActiveTab("airdropreward"); } else { setActiveTab("redeemReward"); } }, [location?.state?.back]); // dependency

    const handleOnclick = () => {
        navigate(`/slot-details/${location?.state?.state}`, { state: { back: location?.state?.back } })
    }




    return (




        <div>
            <div className="mainContent">
                <div className="pageContent def-py-30">
                    <div className='container'>
                        <div className="appPagetitle"><button className='btn btnBack' onClick={handleOnclick}>
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4.16699 10H15.8337" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M4.16699 10L7.50033 13.3333" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M4.16699 10.0003L7.50033 6.66699" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </button> Reward History</div>

                        <div className='row'>
                            <div className="col-lg-12">


                                <div className="appcard mb-4 px-0 pb-2 cardbg">
                                    <div className="cardHeader border-bottom-0 px-4 pb-0">
                                        <Nav pills className='mypillsTabs'>
                                            {!location?.state?.back &&
                                                <NavItem>
                                                    <NavLink
                                                        className={classnames({ active: activeTab === 'airdropreward' })}
                                                        onClick={() => { toggle('airdropreward'); }}
                                                    >
                                                        Airdrop Reward History
                                                    </NavLink>
                                                </NavItem>}

                                            <NavItem>
                                                <NavLink
                                                    className={classnames({ active: activeTab === 'redeemReward' })}
                                                    onClick={() => { toggle('redeemReward'); }}
                                                >
                                                    Royalty Wallet Reward History
                                                </NavLink>
                                            </NavItem>
                                        </Nav>
                                    </div>
                                    <div className="tabcnt">
                                        <TabContent activeTab={activeTab}>
                                            <TabPane tabId="airdropreward">
                                                <AirdropReward />
                                            </TabPane>

                                            <TabPane tabId="redeemReward">
                                                <RedeemReward />
                                            </TabPane>
                                        </TabContent>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default RewardView;